import { useState, useEffect } from 'react';
import {
  FaThLarge,
  FaPaperPlane,
  FaLink,
  FaClipboardList,
  FaShieldAlt,
  FaUsersCog,
  FaLandmark,
  FaHome,
  FaCog,
  FaRobot,
  FaChevronLeft,
  FaUsers,
  FaDatabase,
  FaFolder,
  FaMapMarkedAlt,
  FaTachometerAlt,
  FaChevronDown,
  FaUserTag,
  FaCogs,
} from 'react-icons/fa';
import { FiLogOut } from 'react-icons/fi';
import { NavLink, useLocation } from 'react-router-dom';
import './sidebar.css';
import { useAuth } from '../../context/AuthContext';
import { auditsApi } from '../../features/audits/api/audits.api';
import { toast } from 'react-hot-toast';
import { TOAST_ERROR_IDS } from '../../interaces/toast.ids.interface';
import { navigationTitles } from './navigationTitles';
import { ENUM_ROLES } from '../../interaces/enums/enums.interface';
import { ENUM_PERMISSIONS } from '../../interaces/enums/enums.interface';
function Sidebar({ isOpen, onClose, setIsOpen: _setIsOpen, onMenuClick }) {
  const { hasPrivilege, user, logout, areYouAllowed } = useAuth();
  const { pathname } = useLocation();
  const optionsMenu = [
    {
      label: 'Centro de mando',
      icon: FaThLarge,
      hasPermissions: [
        ENUM_PERMISSIONS.MOD_INTEROP_SERVICES_READ,
        ENUM_PERMISSIONS.MOD_INTEROP_METRICS_READ,
        ENUM_PERMISSIONS.MOD_INTEROP_HISTORY_READ,
        ENUM_PERMISSIONS.MOD_AUDIT_READ,
        ENUM_PERMISSIONS.MOD_NOC_READ,
      ],
      items: [
        {
          to: '/dashboard',
          label: 'Dashboard',
          icon: FaThLarge,
          hasPermission: user?.role === ENUM_ROLES.SUPERADMIN,
        },
        {
          to: '/interoperability',
          label: 'Interoperabilidad',
          icon: FaLink,
          hasPermission:
            hasPrivilege(ENUM_PERMISSIONS.MOD_INTEROP_SERVICES_READ) ||
            hasPrivilege(ENUM_PERMISSIONS.MOD_INTEROP_METRICS_READ) ||
            hasPrivilege(ENUM_PERMISSIONS.MOD_INTEROP_HISTORY_READ),
        },
        {
          to: '/monitoring',
          label: 'NOC / Monitoreo',
          icon: FaTachometerAlt,
          hasPermission: hasPrivilege(ENUM_PERMISSIONS.MOD_NOC_READ),
        },

        {
          to: '/audits',
          label: 'Auditoría Y trazabilidad',
          icon: FaClipboardList,
          hasPermission: hasPrivilege(ENUM_PERMISSIONS.MOD_AUDIT_READ),
        },
      ],
    },
    {
      label: 'Certificados',
      hasPermissions: [
        ENUM_PERMISSIONS.MOD_EMISSION_READ,
        ENUM_PERMISSIONS.MOD_CONFIG_CERT_READ,
        ENUM_PERMISSIONS.MOD_CONFIG_XSD_READ,
        ENUM_PERMISSIONS.MOD_CONFIG_PDF_READ,
       ENUM_PERMISSIONS.MOD_VALIDATION_READ,
        ENUM_PERMISSIONS.MOD_REPORTS_READ,
      ],
      icon: FaShieldAlt,
      items: [
        {
          to: '/emissions',
          label: 'Emisión',
          icon: FaPaperPlane,
          hasPermission: hasPrivilege(ENUM_PERMISSIONS.MOD_EMISSION_READ),
          roles: [ENUM_ROLES.SUPERADMIN, ENUM_ROLES.ADMIN, ENUM_ROLES.DIRECTOR],
        },
        {
          to: '/certificate-configuration',
          label: 'Configuración de certificados',
          icon: FaFolder,
          hasPermission:
            hasPrivilege(ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_READ) ||
            hasPrivilege(ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_XSD_READ) ||
            hasPrivilege(ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_PDF_READ),
        },
        {
          to: '/certificates-validation',
          label: 'Validación de certificados',
          icon: FaShieldAlt,
          hasPermission: hasPrivilege(ENUM_PERMISSIONS.MOD_VALIDATION_READ),
        },
        {
          to: '/reports',
          label: 'Reportes',
          icon: FaUsersCog,
          hasPermission: hasPrivilege(ENUM_PERMISSIONS.MOD_REPORTS_READ),
        },
      ],
    },
    {
      label: 'Dependencias',
      icon: FaLandmark,
      hasPermissions: [ENUM_PERMISSIONS.MOD_DEPENDENCIES_READ, ENUM_PERMISSIONS.MOD_CATASTRO_READ],
      items: [
        {
          to: '/dependencies',
          label: 'Dependencias',
          icon: FaLandmark,
          hasPermission: hasPrivilege(ENUM_PERMISSIONS.MOD_DEPENDENCIES_READ),
        },
        {
          to: '/cadastral',
          label: 'Consulta catastral',
          icon: FaMapMarkedAlt,
          hasPermission: hasPrivilege(ENUM_PERMISSIONS.MOD_CATASTRO_READ),
        },
      ],
    },
    {
      label: 'Configuración',
      hasPermissions: [
        ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_READ,
        ENUM_PERMISSIONS.MOD_ROLES_READ,
        ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_READ,
        ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_SMTP_READ,
        ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_RENAPO_READ,
        ENUM_PERMISSIONS.MOD_DATAMART_READ,
        ,
      ],
      icon: FaCog,
      items: [
        {
          to: '/users-management',
          label: 'Usuarios',
          icon: FaUsers,
          hasPermission: (hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_MANAGEMENT_READ)||hasPrivilege(ENUM_PERMISSIONS.MOD_USERS_INVITATIONS_READ)),
        },
        {
          to: '/roles',
          label: 'Roles',
          icon: FaUserTag,
          hasPermission: hasPrivilege(ENUM_PERMISSIONS.MOD_ROLES_READ),
        },
        {
          to: '/system-configurations',
          label: 'Sistema',
          icon: FaCogs,
          hasPermission:
            hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_READ) ||
            hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_SMTP_READ) ||
           hasPrivilege(ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_RENAPO_READ) 
        },
        {
          to: '/datamart',
          label: 'Datamart',
          icon: FaDatabase,
          hasPermission: hasPrivilege(ENUM_PERMISSIONS.MOD_DATAMART_READ),
        },
      ],
    },
    {
      to: '/ia-assistant',
      label: 'Asistente IA',
      icon: FaRobot,
      hasPermissions: [ENUM_PERMISSIONS.MOD_AI_READ],
    },
  ];

  const [pinnedOpen, setPinnedOpen] = useState(true);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 993);
  const [expandedGroups, setExpandedGroups] = useState(() => {
    const activeGroup = optionsMenu.find(({ items }) =>
      items?.some(({ to }) => pathname === to || pathname.startsWith(`${to}/`))
    );
    return activeGroup ? { [activeGroup.label]: true } : {};
  });

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 993px)');
    const handler = (e) => setIsDesktop(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const handleToggle = () => {
    if (isDesktop) {
      if (pinnedOpen) {
        setExpandedGroups({});
      }
      setPinnedOpen(!pinnedOpen);
    } else if (isOpen) {
      onClose ? onClose() : onMenuClick && onMenuClick();
    } else {
      onMenuClick && onMenuClick();
    }
  };
  const handleGroupToggle = (label) => {
    if (isDesktop && !pinnedOpen) {
      setPinnedOpen(true);
    }
    setExpandedGroups((current) => ({
      ...current,
      [label]: !current[label],
    }));
  };
  const menuItemClasses = (isActive) => `sidevar-link${isActive ? ' sidevar-link-active' : ''}`;

  const logoutSession = async (e) => {
    e.preventDefault();
    try {
      const sessionStart = parseInt(sessionStorage.getItem('sessionStart') || '0', 10);
      const sessionSecs = sessionStart ? Math.round((Date.now() - sessionStart) / 1000) : 0;
      const mins = Math.floor(sessionSecs / 60);
      const secs = sessionSecs % 60;
      const duracionStr = `${mins}m ${secs}s`;

      if (user) {
        await auditsApi.logout({
          username: user.username || user.fullName || 'usuario',
          role: user.role || 'N/A',
          module: 'Dashboard',
          action: 'Cierre de Sesión',
          status: 'Correcto',
          traceability: [
            {
              evento: 'Cierre de Sesión',
              detalle: `El usuario cerró sesión. Duración de sesión: ${duracionStr}`,
            },
          ],
        });
      }
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    } finally {
      logout();
      window.location.href = '/';
    }
  };

  const logoutLink = (
    <NavLink
      to="/"
      className={({ isActive }) => menuItemClasses(isActive) + ' close-session'}
      onClick={(e) => logoutSession(e)}
    >
      <FiLogOut className="icon-sidebar" />
      <span className="sidebar-label">Cerrar sesión</span>
    </NavLink>
  );

  return (
    <aside
      className={`aside-sidebar ${isOpen ? 'left-0-aside' : 'left-less-280'}`}
      data-collapsed={isDesktop && !pinnedOpen ? 'true' : 'false'}
    >
      <div className="div-menu-sidebar-container"
      style={{ boxSizing: 'border-box' }}
      >
        <button
          className="button-menu-sidebar"
          onClick={handleToggle}
          title={
            isDesktop
              ? pinnedOpen
                ? 'Volver al menú compacto'
                : 'Mantener menú abierto'
              : 'Cerrar menú'
          }
        >
          <FaChevronLeft className={`collapse-icon ${!pinnedOpen ? 'collapsed' : ''}`} />
        </button>
        <p className="p-title-sidebar">
          Certificados Digitales
        </p>
      </div>
      <div className="main-div-sidebar">
        <NavLink
          to="/home"
          title={navigationTitles.standard.home}
          className={({ isActive }) => `${menuItemClasses(isActive)} sidebar-home-link`}
        >
          <FaHome className="icon-sidebar sidebar-home-icon" />
          <span className="sidebar-label">{navigationTitles.standard.home}</span>
        </NavLink>
        {optionsMenu
          .filter(({ hasPermissions }) => areYouAllowed(hasPermissions) == true)
          .map(({ to, label, icon: GroupIcon, items, hasPermissions }) => {
            if (to) {
              return (
                <NavLink
                  key={to}
                  to={to}
                  title={label}
                  className={({ isActive }) => menuItemClasses(isActive)}
                >
                  <GroupIcon className="icon-sidebar" />
                  <span className="sidebar-label">{label}</span>
                </NavLink>
              );
            }
            const visibleItems = items.filter(({ hasPermission }) => hasPermission == true);
            if (!visibleItems.length) {
              return null;
            }
            const isExpanded = Boolean(expandedGroups[label]);
            const submenuId = `sidebar-submenu-${label}`;
            return (
              <section className="sidebar-menu-group" key={label}>
                <button
                  type="button"
                  className="sidevar-link sidebar-group-toggle"
                  title={label}
                  aria-expanded={isExpanded}
                  aria-controls={submenuId}
                  onClick={() => handleGroupToggle(label)}
                >
                  <GroupIcon className="icon-sidebar" />
                  <span className="sidebar-label">{label}</span>
                  <FaChevronDown className="submenu-chevron" aria-hidden="true" />
                </button>
                <div className="sidebar-submenu" id={submenuId} hidden={!isExpanded}>
                  {visibleItems.map(({ to: itemTo, label: itemLabel, icon: ItemIcon }) => (
                    <NavLink
                      key={itemTo}
                      to={itemTo}
                      title={itemLabel}
                      className={({ isActive }) =>
                        `${menuItemClasses(isActive)} sidebar-submenu-link`
                      }
                    >
                      <ItemIcon className="icon-sidebar" />
                      <span className="sidebar-label">{itemLabel}</span>
                    </NavLink>
                  ))}
                </div>
              </section>
            );
          })}
        {logoutLink}
      </div>
    </aside>
  );
}

export default Sidebar;
